export default "__VITE_ASSET__BS$STyOJ__"